import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F9F8F6]">
      <div className="max-w-md w-full rounded-2xl border border-slate-200 bg-white p-8 text-center">
        <XCircle className="w-16 h-16 text-slate-400 mx-auto mb-4" />
        <h1 className="font-display text-2xl font-black text-slate-900">Pagamento cancelado</h1>
        <p className="text-slate-500 mt-2">Você pode voltar e tentar novamente quando quiser.</p>
      </div>
    </div>
  );
}
